import React from 'react';
import CollectionNames from '../constant/CollectionNames';
import { RootState } from '../redux/store';
import { changePageFilter, clearPage } from '../redux/actions/PageActions';
import { connect, ConnectedProps } from 'react-redux';
import { FormicaProps, withFormica } from '../helpers/withFormica';
import { CommonConnectionModel } from '../domain/connection/ConnectionDomains';
import ComponentName from '../constant/ComponentName';
import ConnectionListViewerComponent from '../components/connection/ConnectionListViewerComponent';
import ServiceContainer from '../config/ServiceContainer';
import { ServiceNames } from '../constant/ServiceNames';
import ConnectionService from '../service/ConnectionService';
import { ComponentState, setSelectedItems } from '../redux/actions/ComponentActions';
import StandardContainerComponent, { StandardSubscriptionComponentArgs } from '../helpers/StandardContainerComponent';
import LanguageUtil from '../util/LanguageUtil';
import { BulkActionDependencyError } from 'redux/reducers/BulkActionReducer';

class ConnectionContainer extends StandardContainerComponent<Props, State, CommonConnectionModel, CommonConnectionModel> {
  private readonly connectionService: ConnectionService = ServiceContainer.getInstance().get(ServiceNames.CONNECTION);

  constructor(props: Props) {
    const args: StandardSubscriptionComponentArgs = {
      component: ComponentName.CONNECTION,
      withSchema: true,
      itemCollection: CollectionNames.CONNECTIONS,
      label: LanguageUtil.get({ id: `pages.connection.title`, defaultMessage: 'Connections' }),
    };
    super(props, args);
  }

  protected getListView(): React.ReactNode {
    const { items, permissions, itemBuilderView } = this.state;
    return (
      <ConnectionListViewerComponent
        connections={items}
        views={itemBuilderView?.getListViews()}
        currentModal={itemBuilderView?.getLastCurrent()}
        openConnection={this.openComponent}
        onSortChange={this.onSortChange}
        permissions={permissions}
      />
    );
  }

  protected async prepareCount() {
    const count = await this.connectionService.count(this.getCountFilter().build());
    this.setState({ totalRecord: count });
  }

  private getConnectionsFromModal(): string[] {
    const {
      component: { selectedComponentIds },
    } = this.props;
    return selectedComponentIds.map((c: CommonConnectionModel) => c.id);
  }

  protected async deployAll(): Promise<BulkActionDependencyError[]> {
    return await this.connectionService.bulkAction(this.getConnectionsFromModal(), 'Deploy');
  }

  protected async undeployAll(): Promise<BulkActionDependencyError[]> {
    return await this.connectionService.bulkAction(this.getConnectionsFromModal(), 'Undeploy');
  }

  protected async removeAll(): Promise<BulkActionDependencyError[]> {
    return await this.connectionService.bulkAction(this.getConnectionsFromModal(), 'Remove');
  }
}

interface Props extends FormicaProps, ReduxProps {}

class State {}

const mapStateToProps = (state: RootState) => ({
  itemView: state.page.itemView,
  currentCategory: state.page.currentCategory,
  pagePath: state.page.pagePath,
  component: state.component as ComponentState,
  user: state.auth.user,
  attributes: state.auth.attributes,
});
const mapDispatchToProps = { clearPage, setSelectedItems, changePageFilter };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(ConnectionContainer));
